import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ManufacturerLayer from './ManufacturerLayer';
import ClassListLayer from './ClassListLayer';
import GroupListLayer from './GroupListLayer';
import CategoryLayer from './CategoryLayer';
import TargetsLayer from './TargetsLayer';

const tabs = [
  { key: 'groups', label: 'Models & Groups', Component: GroupListLayer },
  { key: 'manufacturer', label: 'Manufacturer', Component: ManufacturerLayer },
  { key: 'class', label: 'Class', Component: ClassListLayer },
  { key: 'category', label: 'Category', Component: CategoryLayer },
  { key: 'targets', label: 'Targets', Component: TargetsLayer },
];

const ModelsGroupsLayer = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(tabs[0].key);

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam && tabs.some(t => t.key === tabParam)) {
      setActiveTab(tabParam);
    }
  }, [searchParams]);

  const ActiveComponent = tabs.find(t => t.key === activeTab).Component;
  return (
    <div className='card h-100 p-0 rounded-0 overflow-hidden'>
      <div className='card-body p-0'>
        <ul className='nav nav-tabs mb-3'>
          {tabs.map(t => (
            <li key={t.key} className='nav-item'>
              <button
                className={`nav-link ${activeTab === t.key ? 'active' : ''}`}
                onClick={() => setActiveTab(t.key)}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
        <ActiveComponent />
      </div>
    </div>
  );
};

export default ModelsGroupsLayer;
